"use client";

import {
    Avatar,
    AvatarBadge,
    AvatarFallback,
    AvatarImage,
} from "@/components/shadcn/avatar";
import { Button } from "@/components/shadcn/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/shadcn/dropdown-menu";
import { Link } from "@/i18n/navigation";
import { ChevronDown, Crown } from "lucide-react";
import { useTranslations } from "next-intl";
import { useSignOut } from "./use-sign-out";

type NavbarProfileProps = {
    user: {
        image?: string | null;
        name: string;
    };
    isPremium: boolean;
};

export function NavbarProfile({ user, isPremium }: NavbarProfileProps) {
    const t = useTranslations("nav");
    const { signOut } = useSignOut();

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" aria-label={t("profileLabel")}>
                    <span
                        className="group/avatar relative flex"
                        data-size="default"
                    >
                        <Avatar>
                            {user.image && (
                                <AvatarImage src={user.image} alt={user.name} />
                            )}
                            <AvatarFallback>
                                {user.name.charAt(0).toUpperCase()}
                            </AvatarFallback>
                        </Avatar>
                        {isPremium && (
                            <AvatarBadge className="top-0 bottom-auto">
                                <Crown />
                            </AvatarBadge>
                        )}
                    </span>
                    <span className="max-w-32 truncate">{user.name}</span>
                    <ChevronDown data-icon="inline-end" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuGroup>
                    <DropdownMenuItem asChild>
                        <Link href="/kullanici">{t("profile")}</Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild>
                        <Link href="/kullanici/ayarlar">{t("settings")}</Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild>
                        <Link href="/kullanici/abonelik">
                            {t("premiumSettings")}
                        </Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        variant="destructive"
                        onSelect={() => void signOut()}
                    >
                        {t("logout")}
                    </DropdownMenuItem>
                </DropdownMenuGroup>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
